import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import Main from "../../components/main";
import history from "../../shared/history";
import {useOsano} from "../../hooks/useOsano";
import {useAmplitude} from "../../hooks/useAmplitude";

export const App = () => {
    const {isOsanoAnalyticsAllowed} = useOsano();
    useAmplitude({
        apiKey: window.AMPLITUDE_API_KEY,
        apiDomain: window.AMPLITUDE_API_DOMAIN,
        shouldOptOut: !isOsanoAnalyticsAllowed
    });

  return (
    <Router history={history}>
      <Switch>
        <Route path="/" exact />
      </Switch>
      <Main />
    </Router>
  );
};

export default App;
